export default __webpack_public_path__ + "static/media/1-infraestruturas.3fe647e6.svg";